import instance from "../utils/axios";

export const userDepositWithdraw = async (data) => {
    return await instance.post('/api/banking/user/deposit_withdraw', data);
};

export const adminDepositFund = async (data) => {
    return await instance.post('/api/banking/admin/deposit', data);
};